<template>
  <div class="main-container">
    <header class="main-header">
      <div class="main-header-left">
        <img src="../assets/peratech_images/400PngdpiLogoCropped.png" alt="로고" class="main-header-logo" style="width: 70px;" @click.stop="recordMap.setView(defaultLocation)" />
      </div>
      <div class="main-header-right">
        <img src="@/assets/images/setting.svg" style="width: 30px; height: 30px; cursor: pointer;" :title="$t('menu')" @click="isShowRecordedList = true"/>
        <!-- <img src="@/assets/images/logout.svg" style="width: 24px; height: 24px; cursor: pointer;" :title="$t('logout')" @click="logout"/> -->
      </div>
    </header>
    <div style="display: flex; width: 100%; height: 100%; align-items: center; justify-content: center;">
      <div style="width: calc(100%); height: calc(100%);">
        <!-- #region 지도 -->
        <div id="recordMap" style="height: 100%; width: 100%; border-radius: 10px;">
          <div>

          </div>
          <div class="map-button-gruop">
            <button @click.stop="recordMap.zoomIn()" :disabled="recordMap && nowZoomLevel === recordMap.getMaxZoom()"><img src="../assets/images/plus.svg" /></button>
            <button @click.stop="recordMap.zoomOut()" :disabled="recordMap && nowZoomLevel === recordMap.getMinZoom()"><img src="../assets/images/minuse.svg" /></button>
            <button @click.stop="isTracking = !isTracking" class="white-button" :style="isTracking ? { background: '#99FF99' } : {}"><img src="../assets/peratech_images/tracking.svg" style="width: 27px; height: 27px;" /></button>
            <button @click.stop="playTime === 1 ? playTime = 2 : playTime === 2 ? playTime = 10 : playTime = 1">X {{ playTime }}</button>
          </div>
          <div v-show="directionHint && directionHint.distanceToUpcomingTurn <= 50 && directionHint.distanceToUpcomingTurn !== 0" class="map-button-gruop" style="left: 50%; right: 0; transform: translateX(-50%); width: 100px;">
            <button @click.stop="" style="width: 70px; height: 60px; display: flex; flex-direction: column; gap: 10px;">
              <img :src="directionImage()" style="width: 27px; height: 27px;" />
              <label>{{ Math.round(directionHint ? directionHint.distanceToUpcomingTurn : 0) }}m</label>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; width: 100%; padding: 10px; padding-top: 0; gap: 10px; justify-content: center;">
      <div class="button-group">
        <button @click.stop="recordStart = true" class="white-button" v-if="!isRecording" :disabled="!marker">🔴 녹화시작</button>
        <button @click.stop="isRecording = false" class="white-button" v-else>{{ formatMsToTime(recordingTime) }}<br>⏹ 녹화중지</button>
      </div>
      
      <div class="button-group" v-if="isReplaying">
        <button @click.stop="!isPaused ? isPaused = true : (recordedMarker.length < 2 ? resetReplay() : isPaused = false)" class="white-button">
          {{ formatMsToTime(replayElapsed) }} / {{ formatMsToTime(replayTimeTotal) }} &nbsp;&nbsp;&nbsp; {{ Math.round(nowReplaySpeed * 3.6) }} km/h
          <br>
          {{ !isPaused ? '⏸️ 리플레이 일시정지' : (recordedMarker.length < 2 ? '🔄️ 리플레이 다시보기' : '▶️ 리플레이 재생') }}
        </button>
      </div>
    </div>
  </div>

  <!-- 알림 컴포넌트 -->
  <NotificationPopup />

  <div v-show="recordStart" class="modal-overlay no-mobile-layout">
    <div class="modal-inside">
      <div style="width: 100%;">
        녹화 설정
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
          <h3>분류</h3>
          <label style="display: flex; align-items: center; gap: 5px; font-size: 13px;">
            <input type="checkbox" style="width: fit-content;" v-model="isSelfCategory"/>
            직접 입력
          </label>
        </div>
        <select v-if="!isSelfCategory" v-model="category">
          <option v-for="route in categoryList" :key="route" :value="route">
            {{ route }}
          </option>
        </select>
        <input v-else type="text" v-model="category"/>

        <h3>제목</h3>
        <input type="text" v-model="title"/>
      </div>
      
      <div class="button-group" style="margin-top: 40px;">
        <button @click="recordStart = false" class="white-button">취소</button>
        <button @click="isRecording = true" class="action-button">시작</button>
      </div>
    </div>
  </div>

  <div v-if="isEditing && editingData" class="modal-overlay no-mobile-layout" style="z-index: 1005;">
    <div class="modal-inside">
      <div style="width: 100%;">
        녹화 수정
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
          <h3>분류</h3>
          <label style="display: flex; align-items: center; gap: 5px; font-size: 13px;">
            <input type="checkbox" style="width: fit-content;" v-model="isSelfCategory"/>
            직접 입력
          </label>
        </div>
        <select v-if="!isSelfCategory" v-model="editingData.route_category">
          <option v-for="route in categoryList" :key="route" :value="route">
            {{ route }}
          </option>
        </select>
        <input v-else type="text" v-model="editingData.route_category"/>

        <h3>제목</h3>
        <input type="text" v-model="editingData.route_title"/>
      </div>
      
      <div class="button-group" style="margin-top: 40px;">
        <button @click="isEditing = false" class="white-button">취소</button>
        <button @click="Put_Route()" class="action-button">저장</button>
      </div>
    </div>
  </div>

  <div v-show="isShowRecordedList" class="modal-overlay no-mobile-layout">
    <div class="modal-inside" style="gap: 20px; position: relative;">
      <span>녹화 목록</span>
      <button class="white-button" style="border-radius: 8px; position: absolute; top: 10px; right: 10px;" @click.stop="isShowDeleted = !isShowDeleted">{{isShowDeleted ? '삭제데이터 숨기기' : '삭제데이터 보기'}}</button>
      <div style="display: flex; gap: 10px;">
        <select v-model="searchCategory">
          <option value="all">전체</option>
          <option v-for="route in categoryList" :key="route" :value="route">
            {{ route }}
          </option>
        </select>
        <input v-model="search" type="text" placeholder="검색" />
      </div>
      <div style="width: 100%;">
        <table>
          <thead>
            <tr>
              <th style="width: 25%;">카테고리</th>
              <th style="">제목<br>시작 시간<br>종료 시간</th>
              <th style="width: 15%;">시간<br>관리</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="route in paginatedData" :key="route.route_id" @click.stop="setReplay(route)" :style="route.is_deleted ? { background: '#EBEBEB' } : {}">
              <td style="text-align: center;">
                {{ route.route_category }}
              </td>
              <td style="padding-left: 10px;">
                {{ route.route_title }}
                <br>
                {{ route.route_value[0].time }}
                <br>
                {{ route.route_value[route.route_value.length - 1].time }}
              </td>
              <td style="text-align: center;">
                {{ formatMsToTime(parseDateString(route.route_value[route.route_value.length - 1].time).getTime() - parseDateString(route.route_value[0].time).getTime()) }}
                <br>
                <div v-if="!route?.is_deleted" style="display: flex; gap: 13px; align-items: center; justify-content: center;">
                  <img @click.stop="Open_Edit_Route(route)" src="@/assets/images/edit.svg"/>
                  <img @click.stop="Delete_Route(route.route_id)" src="@/assets/images/delete.svg"/>
                </div>
                <div v-else>
                  <img @click.stop="Restore_Route(route.route_id)" src="@/assets/images/restore.svg"/>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 페이지네이션 -->
      <div class="pagination-control" style="padding: 0;">
        <div>
          <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
          <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
        </div>
        <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }" :style="currentPage === page ? {cursor: 'default'} : {}">{{ page }}</span>
        <div>
          <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
        </div>
      </div>
      
      <div class="button-group">
        <button @click="isShowRecordedList = false" class="white-button">닫기</button>
      </div>
    </div>
  </div>
</template>

<script setup>
//#region import
import { onMounted, nextTick, onBeforeUnmount, ref, watch, computed } from 'vue';

// 유틸리티 및 설정
import { defaultLocation, firstMapSetting } from '@/utils/MapSetting';
import { formatDate, SendErrorLog } from '@/utils/GlobalUtility';
import L from 'leaflet'

// 컴포넌트 (공통)
import NotificationPopup from "@/components/NotificationPopup.vue";
import { showNotification } from '@/utils/Notification';
import { GET_SERVER_REQUEST, SERVER_REQUEST } from '@/utils/ServerConnect';
//#endregion

const recordMap = ref(null);
const nowZoomLevel = ref(17);
let marker = null
let watchId = null;
const isRecording = ref(false);
const recordStart = ref(false);
const recordList = ref([]);
const recordMarker = ref([]);
const recordedMarker = ref([]);

const title = ref('');
const category = ref('');
const isSelfCategory = ref(false);
const categoryList = computed(() => [...new Set(recordedTotalList.value.map(r => r.route_category))].sort((a, b) => a.localeCompare(b)));

const isShowRecordedList = ref(false);
const recordedTotalList = ref([]);
const recordedList = ref([]);
const searchCategory = ref('all');
const isShowDeleted = ref(false);

const isReplaying = ref(false);
const isPaused = ref(true);
const isTracking = ref(true);

const recordingTime = ref(null);
let ingInterval;
const playTime = ref(1);

const isEditing = ref(false);

onMounted(() => {
  try {
    document.getElementById('app').classList.add('no-mobile-layout');

    nextTick(async () => {
      recordedTotalList.value = await GET_SERVER_REQUEST('rrs');
      if (!document.getElementById('recordMap')) throw new Error('Map container not found');  // 지도 표시 실패시 오류 띄워버리기기
      recordMap.value = await firstMapSetting('recordMap', 17);  // 지도 생성
      recordMap.value?.invalidateSize(); // 지도 크기를 다시 계산
      recordMap.value.on("zoomend", () => {
        nowZoomLevel.value = recordMap.value.getZoom();
      });

      if (navigator.geolocation) {
        watchId = navigator.geolocation.watchPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            
            if (!marker) {
              marker = L.marker([latitude, longitude]).addTo(recordMap.value);
              recordMap.value.setView([latitude, longitude], 16);
            } else {
              marker.setLatLng([latitude, longitude])
            }

            if (isRecording.value) {
              recordList.value.push(
                {
                  lat: latitude,
                  lng: longitude,
                  time: formatDate(new Date()),
                }
              )
              const mark = L.circleMarker(marker.getLatLng(), {
                radius: 5,
                color: '#00DD00',
                opacity: 0.7,
                fillColor: '#00DD00',
                fillOpacity: 0.7,
                time: recordList.value[recordList.value.length - 1].time
              }).addTo(recordMap.value);
              recordMarker.value.push(mark);
            }
          },
          (error) => {
            console.error('위치 정보를 가져오는데 실패했습니다: ', error)
          },
          {
            enableHighAccuracy: true,         // 정확도 향상
            maximumAge: 1000,                 // 최대 캐시 사용 시간 (최근 위치를 몇 ms 까지 재사용하는지)
            timeout: 2000                     // 위치를 못받을경우 몇 ms 뒤 실패처리 할지
          }
        )
      } else {
        alert('이 브라우저는 위치 추적을 지원하지 않습니다.');
      }
    })
  } catch (error) {
    SendErrorLog('Web', error);
  }
});

onBeforeUnmount(() => {
  document.getElementById('app').classList.remove('no-mobile-layout');
  if (watchId) {
    navigator.geolocation.clearWatch(watchId);
  }
});

watch(recordStart, async (newValue) => {
  if (newValue) {
    recordedTotalList.value = await GET_SERVER_REQUEST('rrs');
  }
});

watch(isRecording, async (newValue) => {
  if (watchId) {
    if (newValue) {
      recordStart.value = false;
      recordList.value = [];

      const recordingStartTime = new Date();
      const latlng = marker.getLatLng();
      recordList.value.push(
        {
          lat: latlng.lat,
          lng: latlng.lng,
          time: formatDate(recordingStartTime),
        }
      )
      const mark = L.circleMarker(latlng, {
        radius: 5,
        color: '#00DD00',
        opacity: 0.7,
        fillColor: '#00DD00',
        fillOpacity: 0.7,
        time: recordList.value[recordList.value.length - 1].time
      }).addTo(recordMap.value);
      recordMarker.value.push(mark);

      showNotification('녹화 시작', 'top-center');

      ingInterval = setInterval(() => {
        recordingTime.value = Date.now() - recordingStartTime;
      }, 1000); // 1초 간격으로 녹화 시간 체크
    } else {
      clearInterval(ingInterval);

      showNotification('녹화 종료', 'top-center');

      const totalData = {
        route_title: title.value ?? '박연정',
        route_category: category.value ?? '박연정',
        route_value: recordList.value
      };
      await Post_Route(totalData);

      clearMarkers();
      title.value = '';
      category.value = '';
    }
  } else {
    isRecording.value = false;
  }
});

watch(isShowRecordedList, async (newValue) => {
  if (newValue) {
    recordedTotalList.value = await GET_SERVER_REQUEST('rrs');
  }
});

const Post_Route = async (totalData) => {
  try {
    const jsonData = JSON.stringify(totalData);
    await SERVER_REQUEST('rrs', 'POST', jsonData);
  } catch (error) {
    SendErrorLog(`RouteRecord-Save(${totalData.route_title})`, error);
  }
};

const Delete_Route = async (id) => {
  const totalData = {
    route_id: id
  }
  const jsonData = JSON.stringify(totalData);

  await SERVER_REQUEST('rrs', 'DELETE', jsonData);
  
  recordedTotalList.value = await GET_SERVER_REQUEST('rrs');
};

const Restore_Route = async (id) => {
  const totalData = {
    route_id: id,
    undelete: true
  }
  const jsonData = JSON.stringify(totalData);

  await SERVER_REQUEST('rrs', 'DELETE', jsonData);

  recordedTotalList.value = await GET_SERVER_REQUEST('rrs');
};

const editingData = ref(null);
const Open_Edit_Route = (data) => {
  isEditing.value = true;
  editingData.value = data;
}

const Put_Route = async () => {
  if (!editingData.value) return;

  const totalData = {
    route_id: editingData.value.route_id,
    route_title: editingData.value.route_title ?? '박연정',
    route_category: editingData.value.route_category ?? '박연정',
    route_value: editingData.value.route_value,
  }
  try {
    const jsonData = JSON.stringify(totalData);
    await SERVER_REQUEST('rrs', 'PUT', jsonData);
  } catch (error) {
    SendErrorLog(`RouteRecord-Modify(${totalData.route_title})`, error);
  } finally {
    isEditing.value = false;
    editingData.value = null;
  }
};

const clearMarkers = () => {
  if (!isRecording.value) {
    recordMarker.value.forEach(mark => recordMap.value.removeLayer(mark));
    recordMarker.value = [];
  }
  if (!isReplaying.value) {
    recordedMarker.value.forEach(mark => recordMap.value.removeLayer(mark));
    recordedMarker.value = [];
  }
}

const setReplay = (route) => {
  isReplaying.value = false;
  clearMarkers();

  isShowRecordedList.value = false;
  isReplaying.value = true;
  isPaused.value = true;
  recordedList.value = route.route_value;
  resetReplay();
};

const replayElapsed = ref(0);
const replayTimeTotal = computed(() => {
  const last = recordedList.value[recordedList.value.length - 1];
  const first = recordedList.value[0];
  return parseDateString(last.time).getTime() - parseDateString(first.time).getTime();
})
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
let replayControllerId = 0;
const startReplay = async () => {
  const currentId = ++replayControllerId; // 고유 ID 부여
  replayElapsed.value = 0;

  for (let i = 0; i < recordedList.value.length - 1; i++) {
    if (!isReplaying.value) break;

    nowReplaySpeed.value = speedList[i];
    updatePreviewMarkers();
    
    const timeDiff = parseDateString(recordedList.value[i + 1].time).getTime()
                     - parseDateString(recordedList.value[i].time).getTime();
    let elapsed = 0;
    const step = 100; // 100ms 단위로 체크

    while (elapsed < timeDiff / playTime.value) {
      if (!isReplaying.value || currentId !== replayControllerId) return;

      if (!isReplaying.value) return;
      if (!isPaused.value) {
        await delay(step);
        elapsed += step;
        replayElapsed.value += step * playTime.value;
      } else {
        await delay(step); // 일시정지 중엔 시간 증가 안하도록
      }
    }

    recordMap.value.removeLayer(recordedMarker.value.shift());
  }
  isPaused.value = true;
}
const previewMarkers = ref([]); // 이전 프리뷰 마커 저장용
const updatePreviewMarkers = () => {
  // 이전 프리뷰 마커 제거
  previewMarkers.value.forEach(m => recordMap.value.removeLayer(m));
  previewMarkers.value = [];

  const previewCount = Math.min(10, recordedMarker.value.length - 1);
  for (let i = previewCount; i >= 0; i--) {
    const original = recordedMarker.value[i];
    if (!original) break;

    const latlng = original.getLatLng();
    const opacityStep = 0.8 / previewCount;
    const opacity = (i + 1) * opacityStep;

    const preview = L.circleMarker(latlng, {
      radius: 1,
      color: '#FF0000',
      fillColor: '#FF0000',
      fillOpacity: 1,
      opacity: opacity,
    }).addTo(recordMap.value);

    previewMarkers.value.push(preview);
  }

  if (isTracking.value && previewMarkers.value.length > 0) {
    if (isRecording.value && marker) previewMarkers.value.push(marker);
    const bounds = L.latLngBounds(previewMarkers.value.map(m => m.getLatLng()));
    recordMap.value.setView(bounds.getCenter(), recordMap.value.getZoom());
    // recordMap.value.fitBounds(bounds, { padding: [20, 20] });
  }

  while (recordedList.value.length - recordedMarker.value.length < 0) {
    recordMap.value.removeLayer(recordedMarker.value.shift());
  }
  const nowShowIndex = (recordedList.value.length - recordedMarker.value.length);
  directionHint.value = getNextPrecomputedTurnInfo(directionList, recordedList.value, nowShowIndex);
};

// 리플레이 시작 전에 미리 계산
let directionList;
let speedList;
const resetReplay = () => {
  clearMarkers();

  recordedList.value.forEach(record => {
    const mark = L.circleMarker([record.lat, record.lng], {
      radius: 1,
      color: '#467AED',
      opacity: 0.7,
      fillColor: '#467AED',
      fillOpacity: 0.7,
      time: record.time
    }).addTo(recordMap.value);
    recordedMarker.value.push(mark);
  })
  const bounds = L.latLngBounds(recordedMarker.value.map(marker => marker.getLatLng()));
  recordMap.value.fitBounds(bounds, { padding: [20, 20] });

  directionList = precomputeAllTurns(recordedList.value);
  speedList = calculateSpeedsForPath(recordedList.value);

  startReplay();
};

//#region 시간 표시 관련
const parseDateString = (dateStr) => {
  // YYYY-MM-DD 형식이면 그대로 Date 사용
  if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
    return new Date(dateStr);
  }

  // DD-MM-YYYY 형식 처리 (예: 15-05-2025 06:21:07)
  if (/^\d{2}-\d{2}-\d{4}/.test(dateStr)) {
    const [datePart, timePart] = dateStr.split(' ');
    const [day, month, year] = datePart.split('-');
    const formatted = `${year}-${month}-${day} ${timePart}`;
    return new Date(formatted);
  }

  // fallback
  return new Date(dateStr);
}
const formatMsToTime = (ms) => {
  const totalSec = Math.floor(ms / 1000);
  const minutes = String(Math.floor(totalSec / 60)).padStart(2, '0');
  const seconds = String(totalSec % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
}
//#endregion 



const directionHint = ref('');
/**
 * 두 지점 간의 거리를 미터 단위로 계산합니다 (Haversine formula).
 * @param {number} lat1 위도1
 * @param {number} lon1 경도1
 * @param {number} lat2 위도2
 * @param {number} lon2 경도2
 * @returns {number} 두 지점 간의 거리 (미터)
 */
function getDistanceBetweenPoints(lat1, lon1, lat2, lon2) {
  const R = 6371e3; // 지구 반지름 (미터)
  const phi1 = lat1 * Math.PI / 180;
  const phi2 = lat2 * Math.PI / 180;
  const deltaPhi = (lat2 - lat1) * Math.PI / 180;
  const deltaLambda = (lon2 - lon1) * Math.PI / 180;

  const a = Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
            Math.cos(phi1) * Math.cos(phi2) *
            Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

/**
 * 두 지점 간의 방위각(bearing)을 계산합니다 (0-360도).
 * @param {number} lat1 시작점 위도
 * @param {number} lon1 시작점 경도
 * @param {number} lat2 끝점 위도
 * @param {number} lon2 끝점 경도
 * @returns {number} 방위각 (도)
 */
function getBearingBetweenPoints(lat1, lon1, lat2, lon2) {
  const phi1 = lat1 * Math.PI / 180;
  const phi2 = lat2 * Math.PI / 180;
  const lambda1 = lon1 * Math.PI / 180;
  const lambda2 = lon2 * Math.PI / 180;

  const y = Math.sin(lambda2 - lambda1) * Math.cos(phi2);
  const x = Math.cos(phi1) * Math.sin(phi2) -
            Math.sin(phi1) * Math.cos(phi2) * Math.cos(lambda2 - lambda1);
  const theta = Math.atan2(y, x);
  return (theta * 180 / Math.PI + 360) % 360; // 0-360도 범위로 변환
}

/**
 * 두 방위각 사이의 각도 차이를 계산합니다 (-180 ~ 180도).
 * 양수는 우회전 경향, 음수는 좌회전 경향입니다.
 * @param {number} bearing1 첫 번째 방위각 (도)
 * @param {number} bearing2 두 번째 방위각 (도)
 * @returns {number} 각도 차이 (도)
 */
function calculateAngleDifference(bearing1, bearing2) {
  let difference = bearing2 - bearing1;
  if (difference > 180) difference -= 360;
  else if (difference < -180) difference += 360;
  return difference;
}

// --- 1단계: 전체 경로 분석 함수 ---
/**
 * 전체 경로를 분석하여 모든 턴 지점 정보를 미리 계산합니다 (6개 포인트 기준, 거리 기반 필터링 포함).
 *
 * @param {Array<object>} fullPathPoints - 전체 경로 데이터 배열.
 * 각 요소는 { lat: number, lng: number, ... } 형태여야 합니다.
 * @param {number} [turnAngleThreshold=45] - 턴으로 간주할 최소 각도 변화 (도 단위).
 * @param {number} [windowSize=20] - 각도 변화를 누적할 윈도우 크기 (포인트 개수).
 * @param {number} [minTurnDistance=3] - 턴으로 감지하기 위한 최소 이동 거리 (미터 단위).
 * @returns {Array<object>} - 턴 정보 객체들의 배열. 각 객체는 다음을 포함합니다:
 * - turnAtIndex: {number} fullPathPoints 배열에서 턴이 발생하는 구간의 중간 지점 인덱스 (P2에 해당).
 * - turnType: {'left' | 'right'} 턴 종류.
 * - distanceFromStartToTurnPoint: {number} 경로 시작점부터 이 턴 구간의 시작점까지의 누적 거리 (미터).
 * - coordinates: {object} 턴 구간 시작점의 좌표 { lat, lng }.
 */
function precomputeAllTurns(fullPathPoints, turnAngleThreshold = 45, windowSize = 20, minTurnDistance = 3) {
  if (!fullPathPoints || fullPathPoints.length < windowSize) {
    return [];
  }

  const smoothedPath = smoothPath(fullPathPoints); // 경로 스무딩 적용
  const allTurns = [];
  let accumulatedDistance = 0;

  for (let i = 0; i <= smoothedPath.length - windowSize; i++) {
    const pStart = smoothedPath[i];
    const pMid = smoothedPath[Math.floor(i + windowSize / 2)];
    const pEnd = smoothedPath[i + windowSize - 1];

    const segmentDistance = getDistanceBetweenPoints(fullPathPoints[i].lat, fullPathPoints[i].lng, fullPathPoints[i + 1].lat, fullPathPoints[i + 1].lng);
    if (i > 0) {
      accumulatedDistance += segmentDistance;
    }

    if (getDistanceBetweenPoints(pStart.lat, pStart.lng, pEnd.lat, pEnd.lng) >= minTurnDistance) {
      const bearingStart = getBearingBetweenPoints(pStart.lat, pStart.lng, pMid.lat, pMid.lng);
      const bearingEnd = getBearingBetweenPoints(pMid.lat, pMid.lng, pEnd.lat, pEnd.lng);
      const angleDiff = calculateAngleDifference(bearingStart, bearingEnd);

      // 이전 턴과의 간격 고려 (선택 사항)
      const lastTurnIndex = allTurns.length > 0 ? allTurns[allTurns.length - 1].turnAtIndex : -Infinity;
      if (i + Math.floor(windowSize / 2) > lastTurnIndex + Math.floor(windowSize / 2)) {
        if (Math.abs(angleDiff) >= turnAngleThreshold) {
          allTurns.push({
            turnAtIndex: i + Math.floor(windowSize / 2),
            turnType: angleDiff > 0 ? 'right' : 'left',
            distanceFromStartToTurnPoint: accumulatedDistance + getDistanceBetweenPoints(fullPathPoints[i].lat, fullPathPoints[i].lng, fullPathPoints[i + Math.floor(windowSize / 2)].lat, fullPathPoints[i + Math.floor(windowSize / 2)].lng),
            coordinates: { lat: pMid.lat, lng: pMid.lng },
          });
        }
      }
    }
  }

  return allTurns;
}

// --- 2단계: 현재 위치 기반 다음 턴 정보 조회 함수 ---
/**
 * 미리 계산된 전체 턴 정보와 현재 사용자의 경로상 진행 상황을 바탕으로
 * 다음 턴 안내를 제공합니다 (경로 거리 기반).
 *
 * @param {Array<object>} precomputedTurns - precomputeAllTurns 함수로 생성된 턴 정보 배열.
 * @param {Array<object>} fullPathPoints - 전체 경로 데이터 배열.
 * @param {number} currentPathIndex - 사용자의 현재 위치에 해당하는 fullPathPoints 배열의 인덱스.
 * @param {number} [maxDetectionDistance=300] - 현재 위치로부터 턴을 감지할 최대 전방 경로 거리 (미터 단위).
 * @returns {object | null} - 다음 턴 안내 정보 객체 또는 null.
 * - 턴 안내 객체 예시: { turnType: 'left', distanceToUpcomingTurn: 120.5 }
 */
function getNextPrecomputedTurnInfo(
  precomputedTurns,
  fullPathPoints,
  currentPathIndex,
  maxDetectionDistance = 300
) {
  if (!precomputedTurns || precomputedTurns.length === 0 || currentPathIndex >= fullPathPoints.length - 1) {
    return null; // 미리 계산된 턴이 없거나, 경로 끝에 도달
  }

  let closestTurnInfo = null;
  let minDistanceToTurn = Infinity;

  for (const turnInfo of precomputedTurns) {
    // 해당 턴이 현재 위치 이후에 발생하는지 확인
    if (turnInfo.turnAtIndex > currentPathIndex) {
      let distanceToTurn = 0;
      // 현재 위치부터 턴 시작 지점까지의 경로 거리 계산
      for (let i = currentPathIndex; i < turnInfo.turnAtIndex; i++) {
        distanceToTurn += getDistanceBetweenPoints(
          fullPathPoints[i].lat, fullPathPoints[i].lng,
          fullPathPoints[i + 1].lat, fullPathPoints[i + 1].lng
        );
      }

      if (distanceToTurn <= maxDetectionDistance && distanceToTurn < minDistanceToTurn) {
        minDistanceToTurn = distanceToTurn;
        closestTurnInfo = {
          turnType: turnInfo.turnType,
          distanceToUpcomingTurn: distanceToTurn,
          // Optional: turnAtIndex: turnInfo.turnAtIndex,
          // Optional: turnCoordinates: turnInfo.coordinates
        };
      }
    }
  }

  return closestTurnInfo;
}
/**
 * 경로 데이터에 이동 평균 스무딩을 적용합니다.
 *
 * @param {Array<object>} pathPoints - 경로 데이터 배열 ({ lat, lng } 형태).
 * @param {number} windowSize - 이동 평균을 계산할 창 크기.
 * @returns {Array<object>} - 스무딩된 경로 데이터 배열.
 */
function smoothPath(pathPoints, windowSize = 5) {
  if (pathPoints.length < windowSize) {
    return [...pathPoints]; // 윈도우 크기보다 짧으면 그대로 반환
  }

  const smoothedPoints = [];
  for (let i = 0; i < pathPoints.length; i++) {
    let sumLat = 0;
    let sumLng = 0;
    let count = 0;

    for (let j = Math.max(0, i - Math.floor(windowSize / 2)); j <= Math.min(pathPoints.length - 1, i + Math.floor(windowSize / 2)); j++) {
      sumLat += pathPoints[j].lat;
      sumLng += pathPoints[j].lng;
      count++;
    }

    smoothedPoints[i] = {
      lat: sumLat / count,
      lng: sumLng / count,
      // 필요한 경우 다른 속성도 포함
    };
  }
  return smoothedPoints;
}




const nowReplaySpeed = ref(0);
/**
 * 전체 경로 데이터의 각 지점부터 다음 지점까지의 이동 속도를 계산합니다.
 *
 * @param {Array<object>} fullPathPoints - 전체 경로 데이터 배열.
 * 각 요소는 { lat: number, lng: number, time: string } 형태여야 합니다.
 * time 형식은 "YYYY-MM-DD HH:mm:ss" 또는 "DD-MM-YYYY HH:mm:ss" 등 Date.parse()로 파싱 가능한 형태여야 합니다.
 * @returns {Array<number | null>} - 각 포인트에 대한 속도(m/s) 배열.
 * 마지막 포인트는 다음 포인트가 없으므로 해당 인덱스에는 null이 저장됩니다.
 * 시간 차이가 없거나 음수일 경우 0이 저장됩니다.
 */
function calculateSpeedsForPath(fullPathPoints) {
    const speeds = [];

    if (!fullPathPoints || fullPathPoints.length < 2) {
        // 속도를 계산할 포인트가 부족하거나, 단일 포인트만 있는 경우
        for (let i = 0; i < fullPathPoints.length; i++) {
            speeds.push(null); // 모든 포인트에 대해 null 또는 0으로 처리
        }
        return speeds;
    }

    for (let i = 0; i < fullPathPoints.length; i++) {
        const currentPoint = fullPathPoints[i];

        if (i < fullPathPoints.length - 1) { // 마지막 포인트는 다음 포인트가 없으므로 계산 제외
            const nextPoint = fullPathPoints[i + 1];

            const distance = getDistanceBetweenPoints(
                currentPoint.lat, currentPoint.lng,
                nextPoint.lat, nextPoint.lng
            );

            // 시간 파싱 및 차이 계산
            const timeCurrent = new Date(currentPoint.time);
            const timeNext = new Date(nextPoint.time);

            const timeDifferenceSeconds = (timeNext.getTime() - timeCurrent.getTime()) / 1000; // 밀리초를 초로 변환

            if (timeDifferenceSeconds > 0) {
                speeds.push(distance / timeDifferenceSeconds); // m/s 단위
            } else {
                speeds.push(0); // 시간 차이가 없거나 역행하는 경우 정지 상태로 간주
            }
        } else {
            speeds.push(null); // 마지막 포인트는 다음 지점이 없으므로 속도 계산 불가
        }
    }

    return speeds;
}






//#region 페이지네이션
const currentPage = ref(1);
const itemsPerPage = ref(5);
const showOncePage = ref(5);
// 페이지네이션된 데이터 계산
const totalPages = computed(() => {
  const page = Math.ceil(filteredList.value.length / itemsPerPage.value);
  return page;
});
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filteredList.value.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};

const search = ref("");
const filteredList = computed(() => {
  const query = search.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  let searchedData = recordedTotalList.value;
  searchedData.sort((a, b) => {
    return a.is_deleted - b.is_deleted
  })
  if (!isShowDeleted.value) searchedData = searchedData.filter(data => !data.is_deleted);
  if (searchCategory.value !== 'all') searchedData = searchedData.filter(data => data.route_category === searchCategory.value);

  return searchedData.filter(record => 
    record.route_title.toLowerCase().includes(query)
  );
  // return sortedDeviceList.value.filter(device =>
  // device.device_id.toLowerCase().includes(query) // ID로 검색
  //   || device.device_name.toLowerCase().includes(query) // 이름으로 검색
  //   || device.group_name.toLowerCase().includes(query) // 그룹으로 검색
  //   || device.update_interval.toLowerCase().includes(query) // 주기로 검색
  // );
});

// 현재 보고있는 페이지를 전체 페이지수에 맞춰 자동으로 바꿔줌
watch(
  () => filteredList.value.length,
  () => {
    const newTotalPages = Math.ceil(filteredList.value.length / itemsPerPage.value);
    if (currentPage.value > newTotalPages) {
      currentPage.value = newTotalPages || 1; // 0일 때도 대비
    }
  }
);
//#endregion


import goStrateImage from '@/assets/peratech_images/up-straight-arrow.png';
import goLeftImage from '@/assets/peratech_images/turn-left.png';
import goRightImage from '@/assets/peratech_images/turn-right.png';
const directionImage = () => {
  const direction = directionHint.value?.turnType;
  if (!direction) return goStrateImage;
  else if (direction === 'left') return goLeftImage;
  else if (direction === 'right') return goRightImage;
  else return goStrateImage;
}
</script>

<style scoped>
* {
  font-family: Arial, Helvetica, sans-serif;
}
.modal-inside {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 370px;
  /* height: 500px; */
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 10px;
}
.modal-inside div h3 {
  text-align: left;
  margin: 5px;
  margin-top: 15px;
  color: #000000;
  font-size: 14px;
  font-weight: normal;
}

.map-timer-gruop {
  position: absolute;
  bottom: 5px;
  right: 5px;
  display: flex;
  flex-direction: column; /* 세로 정렬 */
  align-items: flex-end;
  z-index: 500;
  gap: 7px;
}

@media (min-width: 600px) and (max-height: 700px) {
  .main-header {
    height: 30px;
    padding: 0 10px;
  }
}
</style>